import styled, { css } from 'styled-components';

export const Content = styled.input`
  padding: 8px 10px;
  height: auto;
  background-color: #fff;
  border-radius: 3px;
  color: #000;
  border: 1px solid #767676;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      color: #fff;
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      &.fw {
        width: 100%;
      }
      background-color: var(--cp-surface);
      color: var(--cp-text);
      border: 1px solid var(--cp-border);
      border-radius: 8px;
      padding: 8px 12px;
      transition:
        border-color 0.15s ease,
        box-shadow 0.15s ease;
      &::placeholder {
        color: var(--cp-text-tertiary);
      }
      &:hover {
        border-color: var(--cp-green);
      }
      &:focus {
        outline: none;
        border-color: var(--cp-green);
        box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.12);
      }
      ${(props) =>
        props.theme.theme === 'dark' &&
        css`
          background-color: var(--cp-surface);
          color: var(--cp-text);
        `}
    `}
`;
